module.exports = __webpack_public_path__ + "static/media/Chapter3.9a70c6a7.pdf";